import React, { ReactElement } from "react";
import { StepProps } from "../TradeModal";
import { useAuth } from "source/hooks";
import Button from "components/core/Button/Button";
import styles from "./SignedOut.module.scss";

export default function SignedOut(props: StepProps): ReactElement {
  props.setTitle("Join for Free");

  const auth = useAuth();

  return (
    <div>
      <p className={styles.mainMessage}>
        To trade stocks on TiiCKER you must have a free account.
      </p>
      <Button
        className={styles.signUpButton}
        onClick={() => auth.smsSignUp()}
        data-cy="modal-signup"
      >
        Join Now for Free
      </Button>
      <p className={styles.loginMessage}>
        Already a member? <a onClick={() => auth.login()}>Sign In</a>
      </p>
    </div>
  );
}
